
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sync/connectors",
      function () {
        return require("private-next-pages/sync/connectors.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sync/connectors"])
      });
    }
  